import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const basicAuth = btoa(process.env.REACT_APP_BASIC_AUTH);

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_PUBLIC_URL}/`,
    prepareHeaders: (headers) => {
      headers.set("Authorization", `Basic ${basicAuth}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getProtectedApiData: builder.query({
      query: ({ url, lang }) => `${lang}/api/v1/${url}`,
      credentials: "include",
    }),
    getProtectedApiHtml: builder.query({
      query: ({ url, lang }) => `${lang}/node/${url}?_format=json`,
    }),
    getProtected: builder.query({
      query: (url) => `${url}`,
    }),
  }),
});

export const {
  useGetProtectedApiDataQuery,
  useGetProtectedApiHtmlQuery,
  useGetProtectedQuery,
  useLazyGetProtectedApiDataQuery,
} = apiSlice;
